import { Checkbox, Grid, List, ListItem, ListItemText } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useRouteMatch } from 'react-router-dom';
import { Field } from 'redux-form/immutable';

import { selectVolunteerRewardValidationForm } from 'entities/user/selectors';
import SelectableChip from 'retired/SelectableChip';

const UnsetButton = ({ input: { onChange } }) => (
  <SelectableChip onClick={() => onChange(null)} label="Unset" style={{ margin: 0 }} />
);
UnsetButton.propTypes = { input: PropTypes.object };

const FormValueSelector = ({ fields, options, labelText }) => {
  const value = fields.getAll();
  const match = useRouteMatch();
  const volunteerRewardValidationFormId = useSelector(selectVolunteerRewardValidationForm);
  const filteredOptions = options.delete(volunteerRewardValidationFormId);
  // VolunteerRewardValidationForm should not be attached to a deeed

  return (
    <Grid container spacing={3}>
      <Grid item md={6}>
        <Grid container justifyContent="space-between">
          <Grid item style={{ width: '80%' }}>
            <FormControl style={{ width: '100%', height: 17 }}>
              <InputLabel shrink>
                {labelText ||
                  `Select forms for ${
                    match.params.type === 'events' ? `attendees` : `volunteers`
                  } to fill in`}
              </InputLabel>
            </FormControl>
          </Grid>
          <Grid item>
            <Field name="forms" type="radio" component={UnsetButton} />
          </Grid>
        </Grid>
        {filteredOptions.size > 0 ? (
          <List style={{ maxHeight: 300, overflow: 'auto' }}>
            {filteredOptions
              .map((option) => {
                const selected = !!(value && value.includes(option.get('id')));
                const onClick = () => {
                  if (selected) {
                    fields.remove(value.indexOf(option.get('id')));
                  } else {
                    fields.push(option.get('id'));
                  }
                };
                return (
                  <ListItem button onClick={onClick} key={option.get('id')}>
                    <Checkbox color="primary" checked={selected} tabIndex={-1} />
                    <ListItemText primary={option.get('name')} secondary={option.get('subtitle')} />
                  </ListItem>
                );
              })
              .toArray()}
          </List>
        ) : (
          <p>
            No forms created yet. Go to{' '}
            <Link to="/forms" target="_blank">
              forms
            </Link>{' '}
            to create one.
          </p>
        )}
      </Grid>
    </Grid>
  );
};
FormValueSelector.propTypes = {
  options: PropTypes.object.isRequired,
  fields: PropTypes.object.isRequired,
  labelText: PropTypes.string,
};
export default FormValueSelector;
